import * as React from 'react';
import PropTypes from 'prop-types';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import TextField from '@mui/material/TextField';
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  Modal,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { addTag } from '@pingum/app-state-management/tagType/actions';
import { editTag } from '@pingum/app-state-management/tag/actions';

import { LoadingButton } from '@mui/lab';

const AddEditTagModalComponent = ({
  open,
  onClose,
  onEdit,
  onAdd,
  tag,
}) => {
  const dispatch = useDispatch();
  // React state
  const [name, setName] = React.useState('')
  const [isValid, setIsValid] = React.useState(true);
  const [tagType, setTagType] = React.useState(null);

  React.useEffect(() => {
    if (tag) {
      setName(tag.name);
      setTagType(tag.tagType.id);
    } else {
      setName('');
      setTagType(null);
    }
  }, [tag])

  // Redux state
  const { isEditingTag } = useSelector((state) => state.tag);
  const { isAddingTag } = useSelector((state) => state.tagType);
  const selectedBarn = useSelector((state) => state.barn.selectedBarn);

  const handleNameChange = (e) => {
    setName(e.target.value);
  }

  const saveTag = () => {
    const valid
      = name !== null
      && name !== undefined
      && name.length >= 2
      && name.length <= 50
      && tagType != null;

    if (!valid) {
      setIsValid(false);
      return;
    }

    const addTagRequest = {
      name,
      parentTagId: null,
    };
    if (tag === null) {
      dispatch(addTag(parseInt(tagType, 10), addTagRequest)).then((newTag) => {
        setIsValid(true);
        setName('');
        setTagType(null);
        setIsValid(true);
        onAdd(newTag);
      });
    } else {
      dispatch(editTag(tag.id, {
        name,
        tagTypeId: parseInt(tagType, 10),
      }));
      setTimeout(() => {
        setIsValid(true);
        setName('');
        setTagType(null);
        setIsValid(true);
        onEdit({
          ...tag,
          name,
          tagType: {
            ...tag.tagType,
            id: parseInt(tagType, 10),
          },
        })
      }, 500)
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-add-edit-tag"
      aria-describedby="modal-remove-horse-from-barn-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 350,
          bgcolor: 'background.paper',
          pt: 2,
          px: 4,
          pb: 3,
        }}
      >
        <Typography
          id="modal-add-tag-title"
          variant="h6"
          component="h2"
          align="center"
          gutterBottom
          sx={{ mb: 2 }}
        >{`${tag
          ? 'Edit'
          : 'New'} Tag`}
        </Typography>
        <TextField
          error={!isValid && (name.length < 2 || name.length > 50)}
          fullWidth
          helperText={!isValid && 'Tag name must be between 2 and 50 characters'}
          variant="outlined"
          id="tag-name"
          label="Tag Name"
          disabled={isAddingTag || isEditingTag}
          value={name}
          onChange={handleNameChange}
        />
        <FormControl
          error={!isValid && !tagType}
          sx={{
            m: 1,
            width: '100%',
          }}
        >
          <FormLabel id="horse-sex-radio-buttons-group-label">Tag Type</FormLabel>
          <RadioGroup
            row
            aria-labelledby="horse-sex-radio-buttons-group-label"
            name="horse-sex-buttons-group"
            value={tagType}
            disabled={isAddingTag || isEditingTag}
            onChange={(e) => {
              setTagType(e.target.value);
            }}
          >
            <FormControlLabel disabled={isAddingTag || isEditingTag} value={selectedBarn && selectedBarn.barnMetadata && selectedBarn.barnMetadata.tagsTagTypeId} control={<Radio />} label="General" />
            <FormControlLabel disabled={isAddingTag || isEditingTag} value={selectedBarn && selectedBarn.barnMetadata && selectedBarn.barnMetadata.healthTagTypeId} control={<Radio />} label="Health" />
          </RadioGroup>
          <FormHelperText>Use health tags when wanting to map tasks to horse health records</FormHelperText>
        </FormControl>
        <Grid item xs={12} align="right" marginTop={2}>
          <Divider sx={{ mb: 2 }} />
          <Button onClick={() => onClose()} disabled={isAddingTag || isEditingTag}>Cancel</Button>
          <LoadingButton onClick={saveTag} color="primary" variant="contained" disabled={isAddingTag || isEditingTag} loading={isAddingTag || isEditingTag}>Save</LoadingButton>
        </Grid>
      </Box>
    </Modal>
  );
};

AddEditTagModalComponent.propTypes = {
  onAdd: PropTypes.func,
  onEdit: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  tag: PropTypes.object,
  open: PropTypes.bool,
};

AddEditTagModalComponent.defaultProps = {
  onAdd: () => { },
  onEdit: () => { },
  tag: null,
  open: false,
};

export default AddEditTagModalComponent;
